import React, {useEffect, useState} from "react";
import MainLayout from "../MainLoyout/MainLayout";
import {Box, Container, FormControl, InputLabel, Paper, Select} from "@mui/material";
import {useSelector} from "react-redux";
import {DataGrid, GridToolbar} from "@mui/x-data-grid";
import {Circle, Refresh} from "@mui/icons-material";
import Api from "../../Services/Api";
import Title from "../Title";
import MenuItem from "@mui/material/MenuItem";
import Success from "../Snackbar/Success";
import Skeleton from "@mui/material/Skeleton";
import IconButton from "@mui/material/IconButton";


const Users = () => {


    const [apiMessage, setApiMessage] = React.useState(null);
    const [users, setUsers] = React.useState([]);
    const [loading, setLoading] = React.useState([false]);


    useEffect(() => {

        loadStats()

    }, []);

    const loadStats = (data) => {
        setLoading(true)
        Api.users(data).then(r => {
            setUsers(r)
            setLoading(false)

        })
    }

    const columns = [

        {
            field: "active",
            headerName: "Active",
            minWidth: 50,
            type: 'number',
            editable: false,
            flex: 0.1,
            renderCell: (params) => params.row.active ? <Circle color={"success"}/> : <Circle color={"error"}/>

        },
        {
            field: "id",
            headerName: "Id",
            minWidth: 30,
            type: 'number',
            editable: false,
            flex: 0.1,
        },
        {
            field: "name",
            headerName: "Name",
            type: 'string',
            editable: false,
            minWidth: 200,
            flex: 0.4,

        },
        {
            field: "demand",
            headerName: "Is Demand",
            type: 'boolean',
            editable: true,
            minWidth: 100,
            flex: 0.2,

        },
        {
            field: "margin",
            headerName: "Margin %",
            type: 'number',
            editable: true,
            minWidth: 50,
            flex: 0.1,
            valueGetter: (params) => (params.row?.margins?.length ? params.row?.margins[0].margin : params.row?.margin),
            renderCell: (params) => (params.row?.margins?.length ? params.row?.margins[0].margin * 100 + "%" : params.row?.margin * 100 + "%")


        }
    ]


    const LoadingSkeleton = () => (
        <Box
            sx={{
                height: "max-content"
            }}
        >
            {[...Array(20)].map((item, key) => (
                <Skeleton key={key} variant="rectangular" sx={{my: 2, mx: 1}}/>
            ))}
        </Box>
    );

    const onCellEditCommit = (params, event) => {
        Api.updateUser(params).then(r => {
                loadStats()
                setApiMessage(r)
            }
        )
    }

    return (

        <MainLayout>
            <Success successMessage={apiMessage} setSuccessMessage={setApiMessage}>
                {apiMessage?.message}
            </Success>


            <Container maxWidth="xl" sx={{mt: 4, mb: 4}}>
                <Paper sx={{p: 2, display: 'flex', flexDirection: 'column'}}>

                    <Title>Publishers</Title>



                    <DataGrid

                        rows={!loading ? users : []}
                        columns={columns}
                        pageSize={50}
                        autoHeight={true}

                        processRowUpdate={(newRow, oldRow) => {

                            const [updatedField, newValue] = Object.entries(newRow).find(([key, value]) => oldRow[key] !== value) || [];
                            console.log("Field updated: ", updatedField);
                            console.log("New value: ", newValue);
                            Api.updateUser({id: newRow.id, field: updatedField, value: newValue}).then(r => {
                                loadStats()
                                setApiMessage(r)
                            })
                            return newRow


                        }}

                        components={{
                            LoadingOverlay: LoadingSkeleton,
                            Toolbar: GridToolbar,

                        }}
                        componentsProps={{
                            toolbar: {
                                showQuickFilter: true,
                                quickFilterProps: {debounceMs: 500},
                            },
                        }}
                        disableSelectionOnClick
                        disableColumnSelector
                        sx={{
                            mt: 2,
                            mb: 2,
                            minHeight: '600px'
                        }}
                        loading={loading}
                        density={"compact"}
                    />
                </Paper>
            </Container>
        </MainLayout>
    )
}


export default Users